module.exports = __webpack_public_path__ + "static/media/bijlage.55a17ee0.svg";